<mat-expansion-panel
	#expansionPanel
	class="subgroup-panel"
	togglePosition="before"
	(expandedChange)="panelExpansionChange.emit($event)"
	[expanded]="expanded"
>
	<mat-expansion-panel-header>
		<div class="header subgroup-header">
			<span class="info row-info">
				<strong
					class="group-name cart-item-hover"
					[innerHTML]="(group.name | getLocale: group.locale?.group?.name) | highlightMatch:highlightQuery"
					(click)="goToGroup.emit(group); $event.stopImmediatePropagation()"
				></strong>
				<span class="size-count" *ngIf="group.items?.length > 1 && showSizeCount" i18n="Group Items Count@@exportSelectPackagesGroupItemsCount">
					({{ group.items?.length }}&nbsp;sizes)
				</span>
			</span>

			<div class="right-panel">
				<app-item-review-status-sum [items]="group.items"></app-item-review-status-sum>

				<div class="actions" *ngIf="showGroupActions && mode === 'list'">
					<mat-icon
							*ngIf="actionInProgress?.group?.id != group.id"
							class="mt-1"
							(click)="$event.stopImmediatePropagation()"
							[matMenuTriggerFor]="rowMenu"
					>more_horiz</mat-icon
					>
					<mat-icon
							*ngIf="actionInProgress?.group?.id == group.id"
							class="mt-1"
							(click)="$event.stopImmediatePropagation()"
							style="opacity: 0.5"
					>more_horiz</mat-icon
					>
					<mat-menu #rowMenu="matMenu" class="review-context-menu" backdropClass="review-context-menu">
						<div
								mat-menu-item
								*ngIf="showReview && group.type !== CartItemType.VIDEO"
								class="context-menu-item"
								(click)="groupAction.emit({ action: 'approve', group: group })"
						>
							<mat-icon inline>done</mat-icon>
							<ng-container i18n="Group Action@@cartListGroupRowApproveGroupItems">Approve Group Items</ng-container>
						</div>
						<div
								mat-menu-item
								*ngIf="showReview && group.type !== CartItemType.VIDEO"
								class="context-menu-item"
								(click)="groupAction.emit({ action: 'reject', group: group })"
						>
							<mat-icon inline>close</mat-icon>
							<ng-container i18n="Group Action@@cartListGroupRowRejectGroupItems">Reject Group Items</ng-container>
						</div>
						<div mat-menu-item class="context-menu-item delete"
							 *ngIf="!isGuestUser"
							 (click)="deleteItems.emit({ items: group.items, mode: DeleteCartItemMode.Group })"
						>
							<mat-icon inline>delete</mat-icon>
							<ng-container i18n="Group Action@@cartListGroupRowDelete">Delete</ng-container>
						</div>
					</mat-menu>
				</div>
			</div>
		</div>
	</mat-expansion-panel-header>

	<div class="details content-list" *ngIf="group.items | arrayOrDefault as items">
		<app-cart-list-item-row
			*ngFor="let item of items | orderByAlpha : 'metadata.name'"
			class="item"
			[item]="item"
			[mode]="mode === 'checkout' ? 'list' : mode"
			[showDelete]="showDelete"
			[showReview]="showReview"
			[useItemTranslation]="useItemTranslations"
			[actionInProgress]="actionInProgress"
			[highlightQuery]="highlightQuery"
			(goToItem)="goToItem.emit({ item: $event, group: group })"
			(deleteItem)="deleteItem.emit($event)"
			(itemAction)="itemAction.emit($event)"
		></app-cart-list-item-row>
	</div>
</mat-expansion-panel>
